module.exports = __webpack_public_path__ + "img/Rectangle74.45f490e5.png";